import React from 'react';
import SEO from '../components/SEO';

const PrivatumoPolitika = () => {
  return (
    <div>
      <SEO 
        title="Privatumo Politika"
        description="Sporto Krantas privatumo politika - kaip tvarkome jūsų asmens duomenis, slapukų naudojimas ir jūsų teisės."
        keywords="privatumo politika, asmens duomenys, slapukai, BDAR, sporto krantas"
        canonicalUrl="https://sportokrantas.lt/privatumo-politika"
      />
      <section className="py-12 border-b-[3px] border-black bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-black mb-8 tracking-wide leading-tight text-center" style={{ fontSize: '29.5px', fontWeight: 700, WebkitTextStroke: '0.5px' }}>
            PRIVATUMO POLITIKA
          </h1>
          
          <div className="prose prose-lg max-w-none text-black">
            <p className="mb-6">
              Šioje Privatumo politikoje pateikiama informacija apie tai, kaip UAB „Sporto krantas", įmonės kodas 123456789, buveinės adresas Vilniaus r. sav., Sužionių sen., Daukšių km., Liepų g. 63 (toliau – Paslaugų teikėjas) tvarko asmens duomenis.
            </p>

            <p className="mb-6">Privatumo politikos nuostatos yra taikomos fiziniams asmenims, kurių duomenis tvarko Paslaugų teikėjas:</p>
            
            <ul className="list-disc pl-8 mb-6 space-y-2">
              <li>klientams, kurie naudojasi, naudojosi, yra išreiškę ketinimą naudotis arba yra kaip nors kitaip susiję su Paslaugų teikėjo teikiamomis paslaugomis (toliau – Klientai);</li>
              <li>asmenims, kurie kreipiasi į Paslaugų teikėją teikdami prašymus, reikalavimus tiesiogiai arba nuotolinio ryšio priemonėmis, įskaitant telefonu arba el. paštu;</li>
              <li>asmenims, kurie lankosi Paslaugų teikėjo interneto svetainėse ir t.t.</li>
            </ul>

            <h2 className="text-xl font-bold mt-8 mb-4">Sąvokos</h2>
            <p className="mb-4">Šioje Privatumo politikoje naudojamos sąvokos ir sutrumpinimai turi šias reikšmes:</p>
            <ul className="list-disc pl-8 mb-6 space-y-2">
              <li><strong>Asmens duomenys</strong> – bet kokia informacija, susijusi su fiziniu asmeniu, kurį galima tiesiogiai arba netiesiogiai identifikuoti (pvz. vardas, pavardė, kontaktiniai duomenys ir kt.).</li>
              <li><strong>Asmuo</strong> – fizinis asmuo (duomenų subjektas), kurio duomenys yra tvarkomi (pvz. Paslaugų teikėjo Klientai, asmenys, kurie kreipiasi į Paslaugų teikėją, teikdami prašymus, reikalavimus, Paslaugų teikėjo interneto svetainėse, savitarnos svetainėse ir kt.)</li>
              <li><strong>Duomenų tvarkymas</strong> – bet kuris su Asmens duomenimis atliekamas veiksmas (pvz. rinkimas, įrašymas, saugojimas, prieigos suteikimas, perdavimas ir kt.).</li>
              <li><strong>Paslaugos</strong> – bet kokios Paslaugų teikėjo teikiamos prekės ir paslaugos.</li>
            </ul>
            <p className="mb-6">Kitos Privatumo politikoje naudojamos sąvokos suprantamos taip, kaip apibrėžtos asmens duomenų apsaugą reglamentuojančiuose teisės aktuose (Bendrajame duomenų apsaugos reglamente (ES) 2016/679 (toliau – Reglamentas), Lietuvos Respublikos asmens duomenų teisinės apsaugos įstatyme ir kituose).</p>

            <h2 className="text-xl font-bold mt-8 mb-4">Asmens duomenų tvarkymo tikslai ir teisiniai pagrindai</h2>
            <p className="mb-4">Paslaugų teikėjas tvarko Asmens duomenis tik konkrečiais tikslais, vadovaudamasis teisės aktuose nustatytais teisiniais pagrindais:</p>
            <ul className="list-disc pl-8 mb-6 space-y-2">
              <li>kai duomenis tvarkyti būtina, siekiant sudaryti ir (arba) vykdyti su Asmeniu sudarytą sutartį;</li>
              <li>Asmuo davė sutikimą, kad jo duomenys būtų tvarkomi vienu ar keliais konkrečiais tikslais;</li>
              <li>Paslaugų teikėjas privalo tvarkyti Asmens duomenis vykdydamas teisės aktų reikalavimus;</li>
              <li>Asmens duomenis reikia tvarkyti siekiant Paslaugų teikėjo teisėto intereso.</li>
            </ul>

            <h3 className="text-lg font-bold mt-6 mb-3">Pagrindiniai tikslai, kurių siekia Paslaugų teikėjas, tvarkydamas Asmens duomenis:</h3>
            <ul className="list-disc pl-8 mb-6 space-y-3">
              <li><strong>Paslaugų teikimas, sutarčių sudarymas ir vykdymas.</strong> Paslaugų teikėjas tvarko Asmens duomenis, siekdamas užtikrinti tinkamą sutarčių su Klientais sudarymą ir vykdymą, sutarčių pagrindu teikiamų Paslaugų ar prekių Klientams teikimą.</li>
              <li><strong>Atsiskaitymų administravimas.</strong> Paslaugų teikėjas tvarko Asmens duomenis, susijusius su atsiskaitymu už suteiktas Paslaugas, sutarties ir teisės aktų reikalavimų pagrindu.</li>
              <li><strong>Pateiktų klausimų sprendimas.</strong> Paslaugų teikėjas tvarko Asmens duomenis, vykdydamas pateiktų klausimų, skundų nagrinėjimą ir sprendimą.</li>
              <li><strong>Tiesioginė rinkodara.</strong> Paslaugų teikėjas gali tvarkyti Asmens duomenis (vardą, pavardę, el. pašto adresą) teikdamas pasiūlymus, naujienas apie teikiamas Paslaugas, informaciją apie vykstančius renginius.</li>
              <li><strong>Asmenų ir objektų saugumas.</strong> Paslaugų teikėjas, siekdamas užtikrinti savo darbuotojų, Klientų, kitų į vaizdo stebėjimą patenkančių Asmenų bei savo turto ir objektų saugumą, gali vykdyti vaizdo stebėjimą.</li>
            </ul>

            <h2 className="text-xl font-bold mt-8 mb-4">Tvarkomų Asmens duomenų apimtis</h2>
            <p className="mb-4">Pagrindinės Asmens duomenų kategorijos ir duomenys, kuriuos tvarko Paslaugų teikėjas:</p>
            <ul className="list-disc pl-8 mb-6 space-y-2">
              <li><strong>Tapatybės duomenys</strong> – vardas, pavardė, asmens kodas, gimimo data, kt.</li>
              <li><strong>Kontaktiniai duomenys</strong> – adresas, telefono numeris, elektroninio pašto adresas, kt.</li>
              <li><strong>Duomenys, susiję su Paslaugų teikimu</strong> – sutarčių duomenys, duomenys, kuriuos Paslaugų teikėjas gauna bendraudamas su asmenimis tiesiogiai arba nuotolinio ryšio priemonėmis.</li>
              <li><strong>Mokėjimų duomenys</strong> – Paslaugų teikėjui mokėtinos sumos, mokėjimų istorija, kt.</li>
              <li><strong>Slapukų duomenys</strong> – informacija apie Asmens elgesį Paslaugų teikėjo interneto svetainėje, interesus, kt.</li>
            </ul>

            <h2 className="text-xl font-bold mt-8 mb-4">Duomenų saugojimas</h2>
            <div className="overflow-x-auto mb-6">
              <table className="min-w-full border border-gray-300">
                <thead>
                  <tr className="bg-gray-100">
                    <th className="border border-gray-300 px-4 py-2 text-left">Asmens duomenų tvarkymo tikslas</th>
                    <th className="border border-gray-300 px-4 py-2 text-left">Saugojimo terminas</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="border border-gray-300 px-4 py-2">Klientų Asmens duomenų tvarkymas tiesioginės rinkodaros tikslu</td>
                    <td className="border border-gray-300 px-4 py-2">Iki sutikimo galiojimo pabaigos ir po sutikimo galiojimo pabaigos bus saugomi dar 3 metus</td>
                  </tr>
                  <tr>
                    <td className="border border-gray-300 px-4 py-2">Asmens duomenų tvarkymas sutarčių vykdymo tikslu</td>
                    <td className="border border-gray-300 px-4 py-2">Sutarties galiojimo metu ir 10 metų po sutarties pasibaigimo</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <h2 className="text-xl font-bold mt-8 mb-4">Taikomos saugumo priemonės</h2>
            <p className="mb-6">
              Paslaugų teikėjas užtikrina Asmens duomenų konfidencialumą pagal galiojančių teisės aktų reikalavimus ir tinkamų techninių ir organizacinių priemonių, skirtų apsaugoti Asmens duomenis nuo neteisėtos prieigos, atskleidimo, atsitiktinio praradimo, pakeitimo ar sunaikinimo ar kitokio neteisėto tvarkymo, įgyvendinimą.
            </p>

            <h2 className="text-xl font-bold mt-8 mb-4">Asmenų teisės</h2>
            <p className="mb-4">Asmuo, susisiekęs su Paslaugų teikėju, turi teisę:</p>
            <ul className="list-disc pl-8 mb-6 space-y-2">
              <li>susipažinti su Paslaugų teikėjo tvarkomais savo Asmens duomenimis;</li>
              <li>reikalauti ištaisyti neteisingus, neišsamius, netikslius savo Asmens duomenis;</li>
              <li>prašyti sunaikinti Asmens duomenis arba sustabdyti Asmens duomenų tvarkymo veiksmus;</li>
              <li>gauti su savimi susijusius Asmens duomenis susistemintu, įprastai naudojamu ir kompiuterio skaitomu formatu;</li>
              <li>prašyti ištrinti Paslaugų teikėjo tvarkomus Asmens duomenis;</li>
              <li>apriboti savo Asmens duomenų tvarkymą pagal taikomus teisės aktus;</li>
              <li>nesutikti su savo Asmens duomenų tvarkymu ir (arba) bet kada atšaukti duotą sutikimą.</li>
            </ul>

            <h2 className="text-xl font-bold mt-8 mb-4">Asmenų teisių įgyvendinimas</h2>
            <p className="mb-4">Asmenys gali kreiptis dėl Paslaugų teikėjo vykdomo Asmens duomenų tvarkymo:</p>
            <ul className="list-disc pl-8 mb-6 space-y-2">
              <li><strong>Adresas:</strong> Vilniaus r. sav., Sužionių sen., Daukšių km., Liepų g. 63</li>
              <li><strong>Telefonas:</strong> +370 634 00056</li>
              <li><strong>El. paštas:</strong> info@sportokrantas.lt</li>
            </ul>
            <p className="mb-6">
              Nepavykus išspręsti klausimų, susijusių su Paslaugų teikėjo vykdomu Asmens duomenų tvarkymu ir (ar) Asmens teisėmis, Asmuo taip pat turi teisę kreiptis, pateikti skundą Valstybinei duomenų apsaugos inspekcijai.
            </p>

            <h2 className="text-xl font-bold mt-8 mb-4">Privatumo politikos galiojimas ir pakeitimai</h2>
            <p className="mb-6">
              Šioje privatumo politikoje pateikiamos pagrindinės Asmens duomenų tvarkymo nuostatos. Pasikeitus teisės aktų reikalavimams ir/arba Paslaugų teikėjo procesams, teikiamoms paslaugoms ir pan., Paslaugų teikėjas turi teisę vienašališkai pakeisti ir (arba) papildyti šią Privatumo politiką. Apie Privatumo politikos pakeitimus Paslaugų teikėjas informuos, paskelbdamas apie tai Paslaugų teikėjo interneto svetainėje.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivatumoPolitika;

